import tealMarker from 'images/markers/teal.png';
import navyMarker from 'images/markers/navy.png';
import redMarker from 'images/markers/red.png';
import grayMarker from 'images/markers/gray.png';

const getIconColor = (type) => {
  switch (type) {
    case 'Business':
      return '#008080' // teal
    case 'Educational':
      return '#000080' // navy
    case 'Nonmember':
      return '#808080' // gray
    default:
      return '#FF0000' // red
  }
}

const pngMarker = (type) => {
  switch (type) {
    case 'Business':
      return tealMarker;
    case 'Educational':
      return navyMarker;
    case 'Nonmember':
      return grayMarker;
    default:
      return redMarker;
  }
}

const svgMarker = (color) => (`
<svg viewBox="-4 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools --> <title>map-marker</title> <desc>Created with Sketch.</desc> <defs> </defs> <g id="Vivid.JS" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Vivid-Icons" transform="translate(-125.000000, -643.000000)"> <g id="Icons" transform="translate(37.000000, 169.000000)"> <g id="map-marker" transform="translate(78.000000, 468.000000)"> <g transform="translate(10.000000, 6.000000)"> <path d="M14,0 C21.732,0 28,5.641 28,12.6 C28,23.963 14,36 14,36 C14,36 0,24.064 0,12.6 C0,5.641 6.268,0 14,0 Z" id="Shape" fill="${color}"> </path> <circle id="Oval" fill="#FFFFFF" fill-rule="nonzero" cx="14" cy="14" r="6"> </circle> </g> </g> </g> </g> </g> </g></svg>
`)

export {
  getIconColor,
  svgMarker,
  pngMarker,
}